import React from 'react';
import { Mutation } from 'react-apollo';

import mutation from './overrideRotationContactsMutation';
import scheduleChangeRefetch from '../scheduleChangeRefetch';

function buildRefetchQueries({ event: { blockStart, dealerId } }) {
  return () => scheduleChangeRefetch(blockStart, dealerId);
}

const withOverrideRotationContacts = Component => props => (
  <Mutation mutation={mutation} refetchQueries={buildRefetchQueries(props)}>
    {(mutate, { loading }) => {
      const saveEvent = ({ afterHoursEvent, start, end }, contactIds) => {
        const patch = {
          ...contactIds,
          occurrence: {
            kind: 'SINGLE',
            endDate: end.toISOString(),
            startDate: start.toISOString(),
          },
        };

        return mutate({ variables: { id: afterHoursEvent.id, patch } });
      };

      return (
        <Component {...props} saveEvent={saveEvent} isSavingEvent={loading} />
      );
    }}
  </Mutation>
);

export default withOverrideRotationContacts;



// WEBPACK FOOTER //
// ./src/compositions/TechAdmin/DealerDetails/RotationSchedulePanel/RotationOverrideContactsModal/withOverrideRotationContacts.js